import { createApiClient } from "@consistency-circle/api-client";
import { apiBaseUrl } from "./auth-client";

export const apiClient = createApiClient({ baseUrl: apiBaseUrl });
